import { ProfessionIcon } from './profession-icon';

export const IconPainter = () => (
  <ProfessionIcon bg="#EDE7F6">
    <svg width="28" height="28" viewBox="0 0 24 24" fill="none">
      <path
        d="M19 3H5a2 2 0 00-2 2v4a2 2 0 002 2h14a2 2 0 002-2V5a2 2 0 00-2-2z"
        stroke="#7C3AED"
        strokeWidth="1.8"
      />
      <path
        d="M12 11v4"
        stroke="#7C3AED"
        strokeWidth="1.8"
        strokeLinecap="round"
      />
      <rect
        x="10"
        y="15"
        width="4"
        height="6"
        rx="1"
        stroke="#7C3AED"
        strokeWidth="1.8"
      />
    </svg>
  </ProfessionIcon>
);
